export default [
    {
        path: '/dynamic-calendar',
        name: 'dynamic-calendar-index',
        component: () => import('./views/Index.vue'),
        meta: {
            title: 'Calendário Dinâmico',
            icon: 'mdi-calendar-star',
            breadcrumbs: [
                { text: 'Calendário Acadêmico Dinâmico', disabled: true, href: '/' }
            ]
        }
    }
]
